module.exports = __webpack_public_path__ + "Roboto-Medium.fc78759e93a6cac50458.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Medium.woff
// module id = ../../../../../font/roboto/Roboto-Medium.woff
// module chunks = styles